import { CODES } from '~/assets/services/availability';

export default {
    isAvailabilityIn: ({ availability }) => availability === CODES.in,
    isAvailabilityOut: ({ availability }) => availability === CODES.out,
    hasCourierDelivery: ({ shippingMethods }) => shippingMethods && !!shippingMethods.courier,
    variants: ({ variants }) => ((variants && variants.length) ? variants : null),
};
